module.exports = {
      id: "moderated-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#moderated",
      toString: function () {
        return this.url;
      }
    }